"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MenuItem;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _MenuBranch = _interopRequireDefault(require("./MenuBranch"));

var _MenuLeaf = _interopRequireDefault(require("./MenuLeaf"));

var _MenuContext = _interopRequireDefault(require("./MenuContext"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function MenuItem(_ref) {
  _ref = Object.assign({}, {
  BranchComponent: _MenuBranch["default"],
  LeafComponent: _MenuLeaf["default"]
}, _ref);
  var BranchComponent = _ref.BranchComponent,
      LeafComponent = _ref.LeafComponent,
      item = _ref.item,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["BranchComponent", "LeafComponent", "item"]);

  var _useContext = (0, _react.useContext)(_MenuContext["default"]),
      renderItem = _useContext.renderItem;

  var NodeType = LeafComponent,
      result = null;

  if (item.items) {
    NodeType = BranchComponent;
  }

  if (renderItem) {
    result = renderItem(item, item.leaf);
  }

  if (result == null) {
    result = /*#__PURE__*/_react["default"].createElement(NodeType, (0, _extends2["default"])({
      item: item,
      renderItem: renderItem
    }, props));
  }

  return result;
}

MenuItem.propTypes = {
  BranchComponent: _propTypes["default"].elementType.isRequired,
  LeafComponent: _propTypes["default"].any
};
